import { render, staticRenderFns } from "./YanitlarGrafik.vue?vue&type=template&id=81b8df28&"
import script from "./YanitlarGrafik.vue?vue&type=script&lang=js&"
export * from "./YanitlarGrafik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports